import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-presence',
  templateUrl: './our-presence.component.html',
  styleUrls: ['./our-presence.component.css']
})
export class OurPresenceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
